import { Joi } from 'app-webtech-core/schemas';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { SHOW_WELCOME_SCREEN } from './types';

const showWelcomeScreenActionPayloadSchema = Joi.any().optional();

export const layoutShowWelcomeScreenAction = actionCreator(
  SHOW_WELCOME_SCREEN,
  showWelcomeScreenActionPayloadSchema,
);
